export const membershipReserveComf = (state = {}, action) => {
    switch (action.type) {
        case "MEMBERSHIP_RESERVE_COMF": {
            return action.payload.membershipReserveComf;
        }
        default: {
            return state;
        }
    }
};